<template>
  <div class="verify-container">
    <div class="card shadow-lg p-4">
      <h2 class="text-center mb-3">{{ $t('verify.title') }}</h2>
      <p class="text-center">{{ $t('verify.instructions') }}</p>

      <!-- Input pentru codul de verificare -->
      <div class="input-group mb-3">
        <input 
          v-model="verificationCode"
          type="text"
          class="form-control"
          :placeholder="$t('verify.placeholder')"
          required
        />
        <button 
          @click="verifyAccount"
          class="btn btn-primary"
          :disabled="loading"
        >
          <span v-if="loading" class="spinner-border spinner-border-sm"></span>
          {{ $t('verify.verifyButton') }}
        </button>
      </div>

      <!-- Mesaje de succes și eroare -->
      <p v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</p>
      <p v-if="successMessage" class="alert alert-success">{{ successMessage }}</p>

      <!-- Butoane suplimentare -->
      <div class="d-flex justify-content-between mt-3">
        <button @click="resendCode" class="btn btn-outline-primary">
          <i class="fa fa-send me-1"></i> {{ $t('verify.resendButton') }}
        </button>

        <button @click="logout" class="btn btn-outline-danger">
          <i class="fa fa-sign-out me-1"></i> {{ $t("navigation.logout") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.verify-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.card {
  width: 100%;
  max-width: 450px;
  border-radius: 10px;
  background: #ffffff;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
}

h2 {
  font-size: 1.8rem;
  color: #003366;
  font-weight: bold;
}

.input-group {
  display: flex;
}

.form-control {
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 12px;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.btn-primary {
  background-color: #007bff;
  border: none;
  padding: 10px;
  font-size: 1.1rem;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-outline-danger, .btn-outline-primary {
  border-radius: 8px;
  padding: 10px;
  font-size: 1rem;
}

.alert {
  font-size: 0.9rem;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}

.spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      verificationCode: '',
      errorMessage: '',
      successMessage: '',
      loading: false
    };
  },
  methods: {
    async verifyAccount() {
      if (!this.verificationCode.trim()) {
        this.errorMessage = "Introdu un cod valid!";
        return;
      }

      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";

      try {
        await axios.post('https://api.feribot-eurobac.ro/client/api/verify-account/', {
          email: localStorage.getItem('email'),
          code: this.verificationCode.trim()
        });

        this.successMessage = this.$t('verify.successMessage');
        this.loading = false;

        setTimeout(() => {
          this.$router.push('/dashboard');
        }, 2000);
        
      } catch (error) {
        this.errorMessage = this.$t('verify.errorMessage');
        this.loading = false;
      }
    },

    async resendCode() {
      this.errorMessage = "";
      this.successMessage = "";

      try {
        await axios.post('https://api.feribot-eurobac.ro/client/api/resend-code/', {
          email: localStorage.getItem('email')
        });

        this.successMessage = this.$t('verify.resendSuccess');
      } catch (error) {
        this.errorMessage = this.$t('verify.errorMessage');
      }
    },

    async logout() {
      await axios.post("https://api.feribot-eurobac.ro/client/api/logout/", {}, {
        withCredentials: true,
      });
      localStorage.removeItem("email");
      this.$router.push("/login");
    }
  },
  created() {
    if (!localStorage.getItem('email')) {
      this.$router.push('/login');
    }
  }
};
</script>
